import { actionDebug as debug } from '@user/util/debuggers';

export const actions = {
  open({ commit }, name) {
    debug('MODALS/open', name);
    commit('OPEN', name);
  },

  close({ commit }, name) {
    debug('MODALS/close', name);
    commit('CLOSE', name);
  },
};
